import { render } from "./EmployeeUnprocessedRequests.vue?vue&type=template&id=1688f18c"
import script from "./EmployeeUnprocessedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeUnprocessedRequests.vue?vue&type=script&lang=js"

import "./EmployeeUnprocessedRequests.vue?vue&type=style&index=0&id=1688f18c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__